import { render } from "./UserGroupEditDialog.vue?vue&type=template&id=238f7580&scoped=true"
import script from "./UserGroupEditDialog.vue?vue&type=script&lang=js"
export * from "./UserGroupEditDialog.vue?vue&type=script&lang=js"

import "./UserGroupEditDialog.vue?vue&type=style&index=0&id=238f7580&scoped=true&lang=css"

import exportComponent from "/home/utogplukkno/www.utogplukk.no/releases/78563473/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-238f7580"]])

export default __exports__